import { Controller, useForm } from 'react-hook-form'
import { Alert, Box, Button, Grid, MenuItem, TextField } from '@mui/material'

const TenantForm = (props) => {
  const initValue = {
    id: "",
    name: "",
    tenant: "",
    entrytime: "",
  };

  const values = {
    ...initValue,
    ...props.data,
  }

  const {id,name,tenant,entrytime} = values;


  const { register, handleSubmit, control, formState: { errors } } = useForm({
    defaultValues: {id: id,name: name,tenant:tenant,entrytime:entrytime}});

  const onSubmit = (row) => {

    let updateColume = [];
    if(props.data.name != row.name){
      updateColume.push("name")
    }
    if(props.data.tenant != row.tenant){
      updateColume.push("tenant");
    }
    const newData = {
      ...props.data,
      ...row,
      "updateColume": updateColume
    };
    props.process(newData);
  };

  const cancel = () => {
    props.cancel();
  }


  return (
    <>
      <Grid container sx={{ml:1,mt:1,mb:2,mr:2, width: '90%' }}>
        <Grid item xs={10}>
          <TextField
            label="名称"
            fullWidth
            sx={{mb:1,ml:1,mr:1}}
            {...register("name", {
              required: true
            })}
            size="small"
          />
          {errors.name?.type === 'required' && <Alert sx={{width:'70%'}} severity="warning">
            名称は必須です！
          </Alert>}
        </Grid>
        <Grid item xs={10}>
          <TextField
            label="英名（英小文字/数字のみ）"
            fullWidth
            sx={{mb:1,ml:1,mr:1}}
            {...register("tenant", {
              required: true,
              pattern: {
                value: /^[0-9a-z]+$/,
              },
            })}
            size="small"
          />
          {errors.tenant?.type === 'required' && <Alert sx={{width:'70%'}} severity="warning">
            英名は必須です！
          </Alert>}
          {errors.tenant?.type === 'pattern' && <Alert sx={{width:'70%'}} severity="warning">
            英名は英小文字、数字のみが利用できます。
          </Alert>}
        </Grid>
        <Grid item xs={6} >
        </Grid>
        <Grid item xs={6} >
          <Box sx={{mt:1}}>
            <Button variant="contained" onClick={handleSubmit(onSubmit)}>登録</Button>
            <Button sx={{ml:1}} variant="outlined" onClick={cancel}>キャンセル</Button>
          </Box>
        </Grid>
      </Grid>
    </>
  );

}

export default TenantForm